module.exports = __webpack_public_path__ + "static/media/npwp.96909cc8.png";